import { FiCheck } from "react-icons/fi";

const SelectedCircle: React.FC<{ disabled?: boolean; style?: React.CSSProperties }> = ({
    disabled,
    style,
}) => (
    <FiCheck
        size={"1.5em"}
        className={`bg-${disabled ? "secondary" : "primary"} text-white rounded-circle p-1`}
        style={style}
    />
);

export default SelectedCircle;
